import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Footer from "../../../customComponents/Footer";
import "./why-agce.css";



const STATS_TOP = [
  {
    icon: "/images/whyagcx_services_icon.png",
    title: "24/7",
    description: "platform access across web and mobile",
  },
  {
    icon: "/images/whyagcx_services_icon2.png",
    title: "Multi-layered",
    description: "security mindset across account controls",
  },
  {
    icon: "/images/whyagcx_services_icon3.png",
    title: "One ecosystem",
    description: "for trading, convert, earning, and launchpad",
  },
];

const STATS_BOTTOM = [
  {
    icon: "/images/whyagcx_services_icon4.png",
    title: "Native Fiat Support",
    description: "Seamless fiat deposits, withdrawals & conversion.",
  },
  {
    icon: "/images/whyagcx_services_icon5.png",
    title: "Hassle-Free KYC",
    description: "Fast, secure verification for smooth onboarding.",
  },
];

// const PILLARS = [
//   "User-first product experience across web and mobile",
//   "Strong security controls and layered account protection",
//   "Access to trading, earning, and ecosystem products in one platform",
//   "Compliance-focused approach for long-term credibility",
//   "Support for both retail and professional participants",
//   "Scalable foundation for future expansion and innovation",
// ];

// const JOURNEY = [
//   {
//     step: "01",
//     title: "Start fast",
//     text: "Create your account, complete onboarding, and access core products without jumping between disconnected tools.",
//   },
//   {
//     step: "02",
//     title: "Trade with clarity",
//     text: "Use focused product flows for spot, margin, convert, and launchpad with cleaner navigation and practical access points.",
//   },
//   {
//     step: "03",
//     title: "Secure and grow",
//     text: "Add account protections, manage assets, and explore earning options from a platform built around long-term usability.",
//   },
// ];

export default function WhyAgcePage() {
  const userStayRef = useRef(null);
  const [pinState, setPinState] = useState("before");
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 768) {
        setPinState("mobile");
        setScrollProgress(0);
        document.body.classList.remove("whyagcx-pinned");
        return;
      }

      if (!userStayRef.current) return;
      const rect = userStayRef.current.getBoundingClientRect();
      const sectionHeight = userStayRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      const headerOffset = 60;

      const scrolled = headerOffset - rect.top;
      const maxScroll = sectionHeight - windowHeight;

      if (scrolled <= 0) {
        setPinState("before");
        setScrollProgress(0);
        document.body.classList.remove("whyagcx-pinned");
      } else if (scrolled >= maxScroll) {
        setPinState("after");
        setScrollProgress(1);
        document.body.classList.remove("whyagcx-pinned");
      } else {
        setPinState("pinned");
        setScrollProgress(scrolled / maxScroll);
        document.body.classList.add("whyagcx-pinned");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      document.body.classList.remove("whyagcx-pinned");
    };
  }, []);

  const isMobileState = pinState === "mobile";

  const card2Progress = Math.min(1, Math.max(0, (scrollProgress - 0.15) / 0.35));
  const card3Progress = Math.min(1, Math.max(0, (scrollProgress - 0.50) / 0.35));

  const card1Style = isMobileState
    ? undefined
    : { zIndex: 1, transform: "rotate(15deg)" };

  const card2Style = isMobileState
    ? undefined
    : {
      zIndex: 2,
      transform: `rotate(-15deg) translateY(${(1 - card2Progress) * 140}px)`,
      opacity: Math.min(1, card2Progress * 2.5),
    };

  const card3Style = isMobileState
    ? undefined
    : {
      zIndex: 3,
      transform: `rotate(15deg) translateY(${(1 - card3Progress) * 140}px)`,
      opacity: Math.min(1, card3Progress * 2.5),
    };

  return (
    <>
      <Helmet>
        <title>Why AGCX | A Regulated, Secure Crypto Exchange </title>

        <meta
          name="description"
          content="Discover why AGCX is trusted by traders in the UAE and beyond — regulatory compliance, 
          security, deep liquidity, and dedicated support."
        />

        <meta
          name="keywords"
          content="why choose AGCX, regulated crypto exchange UAE, secure crypto trading"
        />
        <link rel="canonical" href="https://arabglobal.ae/why_agcx" />
      </Helmet>

      <div className="wagce-page top-section-gap">
        <section className="wagce-hero">
          <div className="container">
            <div className="wagce-hero__layout">
              <div className="wagce-hero__inner">
                <span className="wagce-eyebrow">Why AGCX</span>
                <h1>Built for users <br></br>
                  who want <br></br>
                  <span>confidence, speed,<br></br>
                    and substance.</span></h1>
                <p>Arab Global Exchange combines a security-minded foundation with
                  a practical trading experience, giving users one place to trade,
                  manage, and grow digital assets with clarity.</p>
                <div className="wagce-actions">
                  <Link to="/signup" className="wagce-btn wagce-btn--primary">
                    Get Started <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link to="/trade/BTC_USDT" className="wagce-btn wagce-btn--ghost">
                    Explore Markets
                  </Link>
                  <Link to="/about_us/company" className="wagce-btn wagce-btn--secondary">
                    Learn About AGCX
                  </Link>
                </div>
              </div>

              <div className="whyagcx_hero_vector">
                <img src="/images/why_agcx_vector.png" alt="why-agcx-hero-right-side" />
              </div>


            </div>
          </div>
        </section>

        <div className="container">
          <div className="wagce-stats-box">
            <div className="wagce-stats-row wagce-stats-row--top">
              {STATS_TOP.map((item) => (
                <div key={item.title} className="wagce-stat-card">
                  <div className="wagce-stat-card__icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="wagce-stat-card__content">
                    <strong>{item.title}</strong>
                    <span>{item.description}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="wagce-stats-row wagce-stats-row--bottom">
              {STATS_BOTTOM.map((item) => (
                <div key={item.title} className="wagce-stat-card">
                  <div className="wagce-stat-card__icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="wagce-stat-card__content">
                    <strong>{item.title}</strong>
                    <span>{item.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <section ref={userStayRef} className={`wagce-section whyagcx_userstay state-${pinState}`}>
          <div className="whyagcx_userstay_wrapper">
            <div className="container">
              <div className="wagce-section__head">
                <h2>Why users stay with AGCX</h2>
                <p className="sub">
                  Everything we build is focused on giving you a safer environment, faster access, and more
                  opportunities to grow with confidence.
                </p>
              </div>

              <div className="why_agcx_user">
                <div className="agcxstay_card" style={card1Style}>
                  <div className="whyagcx_stay_vector">
                    <img src="/images/stay_user_icon.png" alt="why users stay" />
                  </div>
                  <div className="stay_effect">Step 001</div>
                  <div className="cnt_agcxstay_card">
                    <h3>Built for trust</h3>
                    <p>Security-first architecture, controlled access, and transparent operational standards help create a safer trading environment.</p>
                  </div>
                </div>

                <div className="agcxstay_card cardtwoeffect" style={card2Style}>
                  <div className="whyagcx_stay_vector">
                    <img src="/images/stay_user_icon2.png" alt="why users stay" />
                  </div>
                  <div className="stay_effect">Step 002</div>
                  <div className="cnt_agcxstay_card">
                    <h3>Execution that keeps up</h3>
                    <p>Fast interfaces, streamlined flows, and robust market access are designed for both active traders and long-term investors.</p>
                  </div>
                </div>

                <div className="agcxstay_card" style={card3Style}>
                  <div className="whyagcx_stay_vector">
                    <img src="/images/stay_user_icon3.png" alt="why users stay" />
                  </div>
                  <div className="stay_effect">Step 003</div>
                  <div className="cnt_agcxstay_card">
                    <h3>Made for growth</h3>
                    <p>From spot and convert to launchpad, staking, and portfolio tools, AGCX supports users across different stages of their crypto journey.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wagce-section wagce-section--soft">
          <div className="container">

            <div className="agcx_why_services">

              <div className="wagce-section__head wagce-section__head--left">
                <span className="wagce-eyebrow">What Sets Us Apart    <img src="/images/subheading_line.png" width={72} alt="why users stay" /> </span>
                <h2>More than just another exchange <span>front end</span></h2>
                <p>
                  AGCX is being shaped around long-term usability, dependable infrastructure, and
                  responsible expansion so users can focus on decisions, not friction.
                </p>

                <div className="feature_cta d-flex">

                  <div className="feature_vector">
                    <img src="/images/built_vector.png" alt="why users stay" />
                  </div>

                  <div className="features_cnta">
                    <h4>Built for the long run</h4>
                    <p>Every feature and decision is designed to create lasting value for traders and builders.</p>
                  </div>

                </div>


              </div>
              <div className="wagce-list-card">
                <img className="light_img" src="/images/what_agcx_img.png" alt="why users stay" />
                <img className="dark_img" src="/images/what_agcx_img_light.png" alt="why users stay" />
              </div>

            </div>
          </div>
        </section >

        <section className="wagce-section the_experience_section">
          <div className="container">
            <div className="wagce-section__head">
              <span className="wagce-eyebrow"> <img src="/images/subheading_bordereffect.png" width={54} alt="why users stay" /> The Experience  <img className="roatateright" width={54} src="/images/subheading_bordereffect.png" alt="why users stay" /> </span>
              <h2>A simpler path from first action <span>to long-term usage</span></h2>
              <p className="subtext">
                The goal is not just to offer more features, but to make the full platform feel more
                connected, dependable, and useful at every stage.
              </p>
            </div>
            <div className="wagce-journey">

              <div className="term_usages_card terms_onebl">

                <div className="termcard_img">
                  <img src="/images/terms_usage_vector.png" alt="why users stay" />
                </div>
                <div className="cnttermswhy">
                  <h3>Start with <span>Confidence</span></h3>
                  <p>Create your account, complete onboarding, and access core products without jumping between disconnected tools.</p>

                  <div className="number_term">
                    01
                  </div>
                </div>

              </div>


              <div className="term_usages_card">

                <div className="termcard_img">
                  <img src="/images/terms_usage_vector2.png" alt="why users stay" />
                </div>
                <div className="cnttermswhy">

                  <div className="number_term">
                    02
                  </div>
                  <h3>Trade with <span>clarity</span></h3>
                  <p>Use focused product flows for spot, margin, convert, and launchpad with cleaner
                    navigation and practical access points.</p>

                </div>

              </div>



              <div className="term_usages_card terms_onebl">

                <div className="termcard_img">
                  <img src="/images/terms_usage_vector.png" alt="why users stay" />
                </div>
                <div className="cnttermswhy">
                  <h3>Secure <span>and grow</span></h3>
                  <p>Add account protections, manage assets,and explore earning options from a platform
                    built around long-term usability.</p>

                  <div className="number_term">
                    03
                  </div>
                </div>

              </div>


            </div>
          </div>
        </section>

        <section className="wagce-section">
          <div className="container">
            <div className="wagce-cta">
              <div className="cta_cntlft">
                <h2>Explore the platform with a clearer reason to <span>choose it.</span></h2>
                <p>
                  Whether you want to trade actively or build long-term exposure, AGCX is designed to
                  support both with a more reliable and structured experience.
                </p>
                <Link to="/trade/BTC_USDT" className="wagce-btn wagce-btn--primary">
                  Explore Markets <i class="ri-arrow-right-line"></i>
                </Link>
                <Link to="/security_system" className="wagce-btn wagce-btn--secondary">
                  View Security
                </Link>
              </div>
              <div className="wagce-cta__actions">
                <img src="/images/whyagcx_cta.png" alt="why users stay" />
              </div>
            </div>
          </div>
        </section>
      </div >
      <Footer />
    </>
  );
}
